import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { environment } from '@env/environment';
import { AuthQuery } from './auth.query';
import { MODULE_ENV_FLAGS } from '@app/@shared/roles';
import { Logger } from '@core';

const log = new Logger('ModulePermissionGuard');

/**
 * Route guard: module visible when env feature flag (if any) AND role permission allow it.
 * Superuser role (id 1) always passes.
 */
@Injectable({
  providedIn: 'root',
})
export class ModulePermissionGuard implements CanActivate {
  constructor(private router: Router, private authQuery: AuthQuery) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const module: string = (route.data && route.data['module']) || '';

    if (!module) {
      return true;
    }

    if (!this.authQuery.can(module)) {
      log.debug(`Module ${module} not allowed for role ${this.authQuery.role}, redirecting`);
      this.router.navigate(['/error-404'], { replaceUrl: true });
      return false;
    }

    const envFlag = MODULE_ENV_FLAGS[module];
    if (envFlag && !(environment as any)[envFlag]) {
      log.debug(`Module ${module} disabled by env flag ${envFlag}`);
      this.router.navigate(['/error-404'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
